import React from 'react';


const ButtonGroup = (props) => (
    props.node?.groupData ? <></> :

    <span className="isolate inline-flex rounded-md shadow-sm">
      {props.buttons?.map((x,i,arr) => {
        return (
            <button
              key={x.name}
              className={(i === 0 ? "rounded-l-md " : "" ) + "has-tooltip relative inline-flex items-center gap-x-1.5 bg-white px-3 py-2 text-sm font-semibold text-gray-500 ring-1 ring-inset ring-gray-400 hover:bg-gray-200 hover:text-primary-700 focus:z-10" + (i+1 === arr.length ? " rounded-r-md -ml-px" : (i !== 0 ? " -ml-px" : ""))}
              onClick={() => x.onClick(props.data)}
              disabled={x?.disabled}
            >
              {x.icon && <x.icon className="-ml-0.5 h-4 w-4 " aria-hidden="true" />}
              <span className="sr-only">{x.name}</span>
              <span className='tooltip rounded shadow-lg p-1 bg-gray-50 text-primary-500 right-12 border'>{x.name}</span>
              {/* {x.name} */}
            </button>
        )
      })}
     
    </span>
);

export default ButtonGroup;